import { useEffect, useRef, useState } from "react";

// Contador regressivo real até o horário limite (padrão: meia-noite).
// Usa os segundos informados pelo servidor e o relógio local só para o tique — não reinicia sozinho.
const pad = (n) => String(n).padStart(2, "0");

export const DeliveryCountdown = ({ secondsToCutoff, label = "Peça nas próximas", suffix = "" }) => {
  const [left, setLeft] = useState(Math.max(0, secondsToCutoff || 0));
  const endRef = useRef(Date.now() + Math.max(0, secondsToCutoff || 0) * 1000);

  useEffect(() => {
    endRef.current = Date.now() + Math.max(0, secondsToCutoff || 0) * 1000;
    setLeft(Math.max(0, secondsToCutoff || 0));
  }, [secondsToCutoff]);

  useEffect(() => {
    const t = setInterval(() => {
      setLeft(Math.max(0, Math.round((endRef.current - Date.now()) / 1000)));
    }, 1000);
    return () => clearInterval(t);
  }, []);

  if (left <= 0) return null;
  const h = Math.floor(left / 3600);
  const m = Math.floor((left % 3600) / 60);
  const s = left % 60;

  return (
    <span className="inline-flex flex-wrap items-center gap-x-1.5 gap-y-1" data-testid="delivery-countdown">
      {label && <span>{label}</span>}
      <span className="inline-flex items-center gap-1 font-mono font-bold text-gray-900" data-testid="delivery-countdown-timer">
        <span className="bg-gray-900 text-white rounded px-1.5 py-0.5 text-xs">{pad(h)}h</span>
        <span className="bg-gray-900 text-white rounded px-1.5 py-0.5 text-xs">{pad(m)}min</span>
        <span className="bg-gray-900 text-white rounded px-1.5 py-0.5 text-xs">{pad(s)}s</span>
      </span>
      {suffix && <span className="text-gray-500">{suffix}</span>}
    </span>
  );
};
